export default {
    clients: {
        students: '/students',
        vendors: '/vendors',
        districts: '/districts',
    },
    practices: {
        calendar: '/calendar',
        cases: '/cases/list',
        orders: '/orders/list',
        sessions: '/sessions/list',
        'confirmed Analytics': '/provider-analytics',
    },
    services: {
        'service types': '/service-types',
        'service locations': '/service-locations',
    },
    invoices: {
        'Invoices List': '/invoices/list',
        'Pending invoices': '/invoice-docs/list',
    },
    billing: {
        payments: '/payments',
        credits: '/credits',
        'billing log': '/provider-reports',
        'billed hours report': '/session-reports',
        'non-Billed sessions report': '/non-billed-sessions-reports',
        'invoiced hours report': '/invoiced-hours-reports',
        bonuses: '/bonuses',

        expenses: '/expenses',
        internals: '/internals',
        'admin work': '/admin-work',
    },
    payrolls: {
        payrolls: '/payrolls',
        'payrolls reports': '/reports',
        'Received Bonuses': '/received-bonuses',

        deductions: '/deductions',
        'fixed salary': '/wages/list',
    },
    settings: {
        'agency info': '/agency-info',
        'emails log': '/emails-log',
    },

    //HOME: '/',
    //DASHBOARD: '/dashboard',
    //PROVIDERS: '/providers',
    //CASE_CALENDAR: '/cases/2/calendar',

    // SUBSTITUTIONS: '/substitutions',

    //SEANCE_EDIT: `/seances/2/edit`,
    /*STUDENT_CREATE: '/students/create',
    STUDENT_EDIT: '/students/:id/edit',
    STUDENT_INFO: '/students/:id/detail',*/
    // LOGIN_CUSTOMER: '/customer/login',
    //    PROFILE: '/profile',
    // 'PASSWORD RECOVERY': '/password-recovery',
};
